var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreentick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1654 9L17.132 6.675L17.4154 3.6L14.407 2.91667L12.832 0.25L9.9987 1.46667L7.16537 0.25L5.59037 2.90833L2.58203 3.58333L2.86536 6.66667L0.832031 9L2.86536 11.325L2.58203 14.4083L5.59037 15.0917L7.16537 17.75L9.9987 16.525L12.832 17.7417L14.407 15.0833L17.4154 14.4L17.132 11.325L19.1654 9ZM8.40703 12.9333L5.24037 9.75833L6.4737 8.525L8.40703 10.4667L13.282 5.575L14.5154 6.80833L8.40703 12.9333Z",
    fill: "#25D366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreentick);
export default __webpack_public_path__ + "static/media/Greentick.fab3384e3e3ee107655d7c0aa45fde38.svg";
export { ForwardRef as ReactComponent };